import { FETCH_LOCATION_SUCCESS, FETCH_LOCATION_FAILED } from './constants'

export const fetchLocationSuccessAction = payload => ({
  type: FETCH_LOCATION_SUCCESS,
  payload,
})

export const fetchLocationFailedAction = payload => ({
  type: FETCH_LOCATION_FAILED,
  payload,
})
